import { FALSE } from "constants/primitives";
import { YEAR_IN_SECONDS } from "constants/time";
import getTimestamp from "helpers/getTimestamp";

const hasConsentExpired = (
  consentTimestamp: number,
  consentLifetime: number = YEAR_IN_SECONDS
) => {
  // don't expire consents saved before we introduced timestamp saving in the consent object
  if (typeof consentTimestamp !== "number") {
    return FALSE;
  }

  const now = getTimestamp();

  // check if consent timestamp is older than configured
  return now - consentTimestamp >= consentLifetime;
};

export default hasConsentExpired;
